module.exports = __webpack_public_path__ + "static/media/questionmark.01887690.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/questionmark.svg
// module id = 790
// module chunks = 0